import React from 'react';
import { useGetFulfillmentGroupDetailsQuery } from '../../../redux/apis/endpoints/orderApi';
import LoadingSpinner from '../../ui/LoadingSpinner';

const FulfillmentContextMessage = ({ fulfillmentGroupId }) => {
  // Enhanced extraction of the proper ID value
  const normalizedFgId = (() => {
    // If it's already a simple string/number
    if (typeof fulfillmentGroupId === 'string' || typeof fulfillmentGroupId === 'number') {
      return String(fulfillmentGroupId);
    }
    
    // If it's an object with an id property
    if (fulfillmentGroupId && typeof fulfillmentGroupId === 'object') {
      if (fulfillmentGroupId.id) return String(fulfillmentGroupId.id);
      if (fulfillmentGroupId._id) return String(fulfillmentGroupId._id);
    }
    
    // If it can be directly converted to string
    try {
      const strValue = String(fulfillmentGroupId);
      if (strValue && strValue !== '[object Object]' && strValue !== 'undefined') {
        return strValue;
      }
    } catch (e) {
      console.error('Error converting fulfillmentGroupId to string:', e);
    }
    
    return null;
  })();
    
  console.log('FulfillmentContextMessage - normalized ID:', {
    original: fulfillmentGroupId,
    normalized: normalizedFgId,
    type: typeof normalizedFgId
  });
  
  const { data: fgDetails, isLoading, error } = useGetFulfillmentGroupDetailsQuery(
    normalizedFgId,
    {
      skip: !normalizedFgId || normalizedFgId === '[object Object]' || normalizedFgId === 'undefined'
    }
  );
  
  if (!normalizedFgId || normalizedFgId === '[object Object]') {
    return (
      <div className="text-xs text-red-500">
        Invalid fulfillment group reference
      </div>
    );
  }
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-2">
        <LoadingSpinner size="small" />
      </div>
    );
  }
  
  if (error || !fgDetails) {
    return (
      <div className="text-xs text-red-500">
        Could not load order details (ID: {normalizedFgId})
      </div>
    );
  }
  
  const { status, groupType, orderItems = [] } = fgDetails;
  const statusText = status?.replace(/_/g, ' ');
  
  return (
    <div className="w-full">
      {/* Order status header */}
      <div className="mb-2 font-medium text-gray-700 border-b border-gray-200 pb-1">
        <div className="flex items-center">
          <span className="mr-1">{groupType === 'shipping' ? '📦' : '🏬'}</span>
          <span>
            {groupType === 'shipping' ? 'Shipping' : 'Pickup'} Order: {statusText}
          </span>
        </div>
      </div>
      
      {/* Product images - horizontally scrollable */}
      {orderItems.length > 0 && (
        <div className="overflow-x-auto pb-1">
          <div className="flex space-x-2 min-w-min">
            {orderItems.map(item => {
              const product = item.product;
              const imageUrl = product?.photos?.[0]?.url || 'https://via.placeholder.com/80';
              
              return (
                <div 
                  key={item.id} 
                  className="flex-shrink-0 w-16 h-16 bg-gray-200 border border-gray-300 rounded-md shadow-sm overflow-hidden"
                  title={product?.name || 'Product item'}
                >
                  <img 
                    src={imageUrl} 
                    alt={product?.name || 'Item'} 
                    className="h-full w-full object-cover"
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default FulfillmentContextMessage; 